import $ from "jquery";
// import Swiper JS
import Swiper, { Navigation, Pagination, Scrollbar } from 'swiper';
// import Swiper styles
import 'swiper/swiper-bundle.css';
// configure Swiper to use modules
Swiper.use([Navigation, Pagination, Scrollbar]);

console.log("teamslider.js loaded");

// -----------------------------------------------------------------------------
// Initialise Team Sliders – mirrors the approach used by slider_c739.js
// -----------------------------------------------------------------------------

/**
 * @param {JQuery} $slider
 * @param {{ slidesPerViewDesktop?: number, scrollbar?: boolean }} options
 */
function initTextTeamSlider($slider, options) {
    options = options || {};
    var useScrollbar = options.scrollbar !== false;
    var slidesPerViewDesktop = typeof options.slidesPerViewDesktop === 'number' ? options.slidesPerViewDesktop : 2;

    var $scrollbar = $slider.find('.swiper-scrollbar');

    var slidesPerViewMobile = 1.2; // < 768px
    var slidesPerViewTablet = 2;   // ≥ 768px

    if ($slider.data('slides_perview_mobile')) {
        var m = parseFloat($slider.data('slides_perview_mobile'));
        if (m > 0) { slidesPerViewMobile = m; }
    }
    if ($slider.data('slides_perview_tablet')) {
        var t = parseFloat($slider.data('slides_perview_tablet'));
        if (t > 0) { slidesPerViewTablet = t; }
    }
    if ($slider.data('slides_perview_desktop')) {
        var d = parseFloat($slider.data('slides_perview_desktop'));
        if (d > 0) { slidesPerViewDesktop = d; }
    }

    $slider.css('opacity', 0);

    var swiperConfig = {
        slidesPerView: slidesPerViewMobile,
        spaceBetween: 20,
        grabCursor: true,
        on: {
            init: function () {
                $slider.animate({ opacity: 1 }, 400);
            }
        },
        breakpoints: {
            768: { slidesPerView: slidesPerViewTablet },
            1260: { slidesPerView: slidesPerViewDesktop }
        }
    };

    if (useScrollbar && $scrollbar.length) {
        swiperConfig.scrollbar = {
            el: $scrollbar[0],
            hide: false
        };
    }

    new Swiper($slider[0], swiperConfig);
}

$('.text_teamslider_swiper').each(function () {
    initTextTeamSlider($(this), { slidesPerViewDesktop: 2, scrollbar: true });
});

$('.text_teamslider_top_swiper').each(function () {
    initTextTeamSlider($(this), { slidesPerViewDesktop: 3, scrollbar: false });
});
